import { createSlice, current } from '@reduxjs/toolkit';

const initialReportState = {
  accountSearchFilter: { search_type: '', search_data: '' },
  repotAccountList: { list: [], cursor_id: '' },
  reportDownloadSuccess: false,
};

const reportSlice = createSlice({
  name: 'reportData',
  initialState: initialReportState,
  reducers: {
    updateReportAccountList(state, { payload }) {
      state.repotAccountList = payload;
    },
    updateAccountSearchFilter(state, { payload }) {
      state.accountSearchFilter = payload;
    },
    downloadFileSuccess(state) {
      state.reportDownloadSuccess = true;
    },
    resetDownloadFileStatus(state) {
      state.reportDownloadSuccess = false;
    },
    clearReportAccountList(state) {
      state.repotAccountList = { list: [], cursor_id: '' };
    },
    clearAccountSearchFilter(state) {
      state.accountSearchFilter = { search_type: '', search_data: '' };
    },
    clearReportSlice: () => initialReportState,
  },
});

export const {
  updateReportAccountList,
  updateAccountSearchFilter,
  clearReportAccountList,
  clearAccountSearchFilter,
  clearReportSlice,
  downloadFileSuccess,
  resetDownloadFileStatus,
} = reportSlice.actions;
export default reportSlice.reducer;
